import { createContext } from 'react'
import { Trans } from 'react-i18next'

import { TFunction } from 'i18next'

type RootContextValue = {
  t?: TFunction
  trans?: typeof Trans
}

const RootContext = createContext<RootContextValue>({})

export default RootContext
